import React from 'react';
import {Anchor, Banner, Text} from '@albert-io/atomic';

interface ArchivedQuestionBannerProps {
  classname?: string;
}

export const ArchivedQuestionBanner: React.FC<ArchivedQuestionBannerProps> = ({classname}) => {
  return (
    <Banner align='left' type='warning' border={false} className={`block ${classname}`}>
      <Banner.Icon icon={['far', 'box-archive']} />
      <Text as='div' color='inherit'>
        This question is archived; it can no longer be added to new assignments. Learn more about
        why we archive questions{' '}
        <Anchor
          href='https://help.albert.io/en/articles/12754786-what-are-archived-questions'
          target='_blank'
        >
          here
        </Anchor>
        .
      </Text>
    </Banner>
  );
};

export default ArchivedQuestionBanner;
